import request from "@/utils/request";

//获取合作商基础
function getPartner(params) {
  return request({
    url: "/api/app/partner.php?action=show",
    method: "get",
    params,
  });
}
//获取合作商其它配置信息
function getPartnerSetting(params) {
  return request({
    url: "/api/app/partner.php?action=setting",
    method: "get",
    params,
  });
}
//速8手机上报
function super8(params) {
  return request({
    url: "/api/app/brand.php?action=su8uid",
    method: "get",
    params,
  });
}
export { getPartner, getPartnerSetting, super8 };
